import React from 'react';
import Icons from '../../../Containers/Icons';
import lang from '../../Lang/lang.json';

let BackupDBFiles = (props) => {
  let {files, url, openMod, restore, type, language} = props;
  let folder;
  if (type === "db") {
    folder = "backup/";
  } else if (type === "img") {
    folder = "backupImg/";
  }
  if (files) {
    return (
      <ul>{
        files.map((file, key) => {
          return (
            <li key={key}>
              <span className="filetitle">{file}</span>
              <a href={url + folder + file} className="download-icon">
                <Icons name="download"/>
              </a>
              <span className="trashbin" onClick={() => openMod(file)}>
                <Icons name="trash"/>
              </span>
              <span className="restore" onClick={() => restore(file)}>
                <Icons name="load"/>
              </span>
            </li>
          )
        })
      }</ul>
    )
  } else {
    return (
      <div>{lang.BackupDB.loading[language]}</div>
    )
  }
}
export default BackupDBFiles;


// WEBPACK FOOTER //
// ./src/Components/Admin/Backup/BackupDBFiles.js